import React from "react";

import SkeletonElement from "./BasicSkeleton/SkeletonElement";
import SkeletonAnimation from "./BasicSkeleton/SkeletonAnimation";

const WalletImageSkeleton = () => {
  return (
    <div className="wallet-skeleton">
      <div className="flex-fill">
        <div className="wallet-skeleton-gangsta ">
          <div className="mx-auto mt-2 wallet-card-container d-flex justify-content-center justify-content-sm-start flex-wrap">
            <SkeletonElement type="img" />
            <SkeletonElement type="img" />
            <SkeletonElement type="img" />
            <SkeletonElement type="img" />
          </div>
        </div>
        <SkeletonAnimation />
      </div>
    </div>
  );
};

export default WalletImageSkeleton;
